import { render } from "./practice-people-trust-coordinator.html?vue&type=template&id=cda6c734&scoped=true&ts=true&external"
import script from "./practice-people-trust-coordinator.ts?vue&type=script&lang=ts&external"
export * from "./practice-people-trust-coordinator.ts?vue&type=script&lang=ts&external"

import "./practice-people-trust-coordinator.scss?vue&type=style&index=0&id=cda6c734&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cda6c734"]])

export default __exports__